const layout = (state) => state.layout;

export const sidebarIsVisible = (state) => layout(state).sidebarIsVisible;

export const isMobile = (state) => layout(state).isMobile;
